import { Spinner } from "../../../../atoms";

const HistoryTemplateApiLoading = () => {
  return (
    <Spinner></Spinner>
  );
};

export default HistoryTemplateApiLoading;
